export const updateInvestigationRoadAccidentService =
  (fetch) => async (investigation) => {
    try {
      const response = await fetch({
        url: `/api/v1/siniestros-viales/investigaciones/${investigation.id}`,
        method: "put",
        body: investigation,
      });
      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
